export const mockExample = `const myMock = jest.fn();
console.log(myMock());  //> undefined

//Inyecta valores de retorno
myMock.mockReturnValue('Hola');
console.log(myMock());    //> "Hola"
myMock
.mockReturnValueOnce(2).mockReturnValueOnce(5)
console.log(myMock(), myMock());       //> 2, 5`;



// WEBPACK FOOTER //
// ./src/slides/02-unit-testing/02-core-concepts/code-examples/05-mocks-examples.js